import React from "react";
import PropTypes from "prop-types";
import { Modal, Tabs, Icon, Button } from "antd";
import KycDocViewer from "./kyc-doc-viewer";
import { COMPANY_DOCUMENT_TILES } from "../constants";

const { TabPane } = Tabs;

function tabTitle(label, present) {
    return (
        <span className={"cc-kyc-tab"}>
            <Icon
                type={present ? "check-circle" : "exclamation-circle"}
                theme={present ? "filled" : "outlined"}
                className={present ? "cc-kyc-tab--ok" : "cc-kyc-tab--missing"}
            />
            {label}
        </span>
    );
}

/**
 * Max-screen viewer for the company verification documents (GST certificate,
 * utility bill, shop photo). One tab per document; tabs whose document is not on
 * file render the viewer's empty state so a missing doc reads as a finding.
 */
class CompanyDocViewerModal extends React.Component {
    state = { tab: null };

    componentDidUpdate(prevProps) {
        if (
            this.props.visible &&
            !prevProps.visible &&
            this.props.initialTab &&
            this.props.initialTab !== this.state.tab
        ) {
            this.setState({ tab: this.props.initialTab });
        }
    }

    handleTab = tab => this.setState({ tab });

    render() {
        const { visible, onClose, docs, companyName, title } = this.props;
        if (!docs) {
            return null;
        }
        const tiles = this.props.tiles || COMPANY_DOCUMENT_TILES;
        const firstPresent = tiles.find(tile => docs[tile.key]);
        const active =
            this.state.tab ||
            (firstPresent && firstPresent.key) ||
            tiles[0].key;
        return (
            <Modal
                visible={visible}
                onCancel={onClose}
                footer={null}
                width={"98vw"}
                destroyOnClose
                className={"cc-modal cc-kyc-modal cc-kyc-modal--max"}
                title={
                    <div className={"cc-kyc-modal__title"}>
                        <span>{title || "Company Documents"}</span>
                        {companyName ? (
                            <span className={"cc-kyc-modal__subtitle"}>
                                {companyName}
                            </span>
                        ) : null}
                    </div>
                }
            >
                <div className={"cc-kyc-modal__docfull"}>
                    <Tabs
                        activeKey={active}
                        onChange={this.handleTab}
                        animated={false}
                    >
                        {tiles.map(tile => (
                            <TabPane
                                tab={tabTitle(tile.label, Boolean(docs[tile.key]))}
                                key={tile.key}
                            >
                                {/* Ledger isn't an uploaded file — it's generated
                                    on demand, so the Ledger tab carries a Download
                                    button (rest of the tabs just view the file). */}
                                {tile.key === "ledger" &&
                                this.props.onDownloadLedger ? (
                                        <div className={"cc-kyc-modal__actions"}>
                                            <Button
                                                icon={"download"}
                                                size={"small"}
                                                onClick={
                                                    this.props.onDownloadLedger
                                                }
                                            >
                                                Download
                                            </Button>
                                        </div>
                                    ) : null}
                                <KycDocViewer
                                    filePath={docs[tile.key] && docs[tile.key].file}
                                    directUrl={docs[tile.key] && docs[tile.key].url}
                                />
                            </TabPane>
                        ))}
                    </Tabs>
                </div>
            </Modal>
        );
    }
}

CompanyDocViewerModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    docs: PropTypes.object,
    companyName: PropTypes.string,
    title: PropTypes.string,
    tiles: PropTypes.array,
    initialTab: PropTypes.string,
    // Optional — shown only on the Ledger tab (the ledger is generated, not an
    // uploaded file), triggers the ledger download.
    onDownloadLedger: PropTypes.func
};

export default CompanyDocViewerModal;
